import React, { useEffect, useState } from 'react';
import { Clock, Flame } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 50
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) return prev;
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="bg-[#c0392b] text-white py-3 px-4 text-center font-bold sticky top-0 z-50 shadow-md" data-id="element-239">
      <div className="flex flex-col md:flex-row justify-center items-center gap-2 md:gap-4 text-sm md:text-base uppercase tracking-wide" data-id="element-240">
        <div className="flex items-center gap-2" data-id="element-241">
          <Clock className="w-5 h-5" data-id="element-242" />
          <span data-id="element-243">
            Oferta expira en:{' '}
            <span className="bg-white text-[#c0392b] px-2 py-0.5 rounded font-mono text-lg" data-id="element-244">
              {formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)}
            </span>
          </span>
        </div>
        <div className="hidden md:block" data-id="element-245">|</div>
        <div className="flex items-center gap-2 animate-pulse" data-id="element-246">
          <Flame className="w-5 h-5 text-yellow-300" data-id="element-247" />
          <span data-id="element-248">Solo quedan 5 accesos con descuento</span>
        </div>
      </div>
    </div>;
}